// src/com/veh_route/VehRouteDict.js
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import Battery6BarIcon from '@mui/icons-material/Battery6Bar';
import { AppObject, AppWord, TableColumnType } from "../../value/AppConst";
import ValueMisc from '../../value/ValueMisc';
import MarkerUtil from "../map/MarkerUtil";

export function parseMidRoute(midRoute) {
    // midRoute example: [[54,33.3295606, 126.3447805],[36,33.3288605, 126.3440594],[18,33.3283905, 126.3434894]]
    const points = [];
    if(midRoute===null || midRoute==='[]') return points;

    try {
        const json = `{ "midRoute": ${midRoute} }`;

        const route = JSON.parse(json).midRoute;
        if(Array.isArray(route)) {
            for(const rec of route) {
                // points.push(new MidPointVo(csv));
                if(rec.length!==3) continue;
                const [diffSeconds, lat, lon] = rec;
                if(lat > 30 && lat < 40 && lon > 120 && lon < 140) {
                    points.push({diffSeconds, lat, lon});
                }
            }
        }
    }
    catch(e) {}

    return points;
}

/**
 * VEH_ROUTE React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-11-18 12:39:26 using DbdbTap
 */
export const VehRouteDictionary = {
    errorTitle: {
        Get: '차량경로 조회 오류',
    },
    floatingInfoProps: [
        {id: 'gpsTime', label: '보고시각', },
        {id: 'location', label: '위치', },
        {
            id: 'posSys', label: '위치방식',
            print: (rec, value) => {
                if(value==='C') return '기지국 위치';
                if(value==='L') return '과거 위치';
                return 'GPS 위치';
            }
        },
        {
            id: 'speed', label: '속도(km/h)',
            print: (rec, value) => {
                const dirIdx = MarkerUtil.degreeToIndex16(rec.direction);
                const dirKor = AppObject.directionKorean16[dirIdx];
                return `${value} km/h (${dirKor}향)`;
            }
        },
        {id: 'distKm', label: '누적거리(km)', print: (rec, value) => value ? ValueMisc.float2str(value, 1) : value},
        {id: 'tempr1', label: '전면온도', print: (rec, value) => value < -100 ? '-' : `${value}°C`},
        {id: 'tempr2', label: '후면온도', print: (rec, value) => value < -100 ? '-' : `${value}°C`},
        {id: 'tempr3', label: '중면온도', print: (rec, value) => value < -100 ? '-' : `${value}°C`},
        {id: 'vehAlias', label: '지도표시명', },
    ],
    tableProps: {
        tableId: 'vehRouteTable',
        uniqueKey: 'gpsTime',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: true, // 외부에서 MapFloatingInfo를 사용해서 표시
            growToFill: true,
        },
        columns: [
            { id: 'gpsTime', label: '보고시각', width: 165, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'location', label: '위치', width: 350, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'speed', label: '속도(Km/h)', width: 90, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'distKm', label: '운행거리(Km)', width: 100, show: true,
                option:{align: 'right', print:(r,i,v)=>v?ValueMisc.float2str(v/1000,2):'0.00'} },
            { id: 'pwrType', label: '전원타입', width: 60, show: true,
                option:{align: 'center',
                    print:(r,i,v)=>v===1 ? <Battery6BarIcon fontSize={AppWord.SMALL}/> : <ElectricalServicesIcon fontSize={AppWord.SMALL}/>
                } },
            { id: 'posSys', label: '위치타입', width: 80, show: true,
                option:{align: 'center',
                    print:(r,i,v)=>{
                        if(v==='G') return 'GPS';
                        else if(v==='L') return '과거위치';
                        else if(v==='I') return 'ITS';
                        else if(v==='C') return 'Cell';
                        else return '-';
                    }
                 } },
            { id: 'tempr1', label: '전면온도', width: 70, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tempr3', label: '중면온도', width: 70, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tempr2', label: '후면온도', width: 70, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'irActionName', label: '업무상태', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            /*
            { id: 'vehPlates', label: Dict.vehPlates.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehAlias', label: Dict.vehAlias.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comId', label: Dict.comId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'custId', label: Dict.custId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehId', label: Dict.vehId.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'gpsDatetime', label: Dict.gpsDatetime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'gpsTime', label: Dict.gpsTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'vehInfoSeq', label: Dict.vehInfoSeq.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'devId', label: Dict.devId.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'termId', label: Dict.termId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'recvTime', label: Dict.recvTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'insertTime', label: Dict.insertTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'gpsLat', label: Dict.gpsLat.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'gpsLon', label: Dict.gpsLon.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'xDist', label: Dict.xDist.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'yDist', label: Dict.yDist.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'location', label: Dict.location.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'speed', label: Dict.speed.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'distKm', label: Dict.distKm.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'direction', label: Dict.direction.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'statusCode', label: Dict.statusCode.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'eventCd', label: Dict.eventCd.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'svcCondCd', label: Dict.svcCondCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'loadCondCd', label: Dict.loadCondCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'gpioBits', label: Dict.gpioBits.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'pwrType', label: Dict.pwrType.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'posSys', label: Dict.posSys.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'paraDiff', label: Dict.paraDiff.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'meridCode', label: Dict.meridCode.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'cycleMake', label: Dict.cycleMake.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'cycleReport', label: Dict.cycleReport.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'custPoiCode', label: Dict.custPoiCode.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'doorEvent', label: Dict.doorEvent.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'door0', label: Dict.door0.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.BOOLEAN} },
            { id: 'door1', label: Dict.door1.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.BOOLEAN} },
            { id: 'door2', label: Dict.door2.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.BOOLEAN} },
            { id: 'tempr1', label: Dict.tempr1.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tempr2', label: Dict.tempr2.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tempr3', label: Dict.tempr3.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tempr4', label: Dict.tempr4.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'itinRepType', label: Dict.itinRepType.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'irLat', label: Dict.irLat.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'irLon', label: Dict.irLon.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'irYCoord', label: Dict.irYCoord.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'irXCoord', label: Dict.irXCoord.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'irDist', label: Dict.irDist.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'irMins', label: Dict.irMins.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'irPoiType', label: Dict.irPoiType.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'irPoiSeq', label: Dict.irPoiSeq.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'irAction', label: Dict.irAction.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'addrPrefix', label: Dict.addrPrefix.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'poiName', label: Dict.poiName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'poiDistM', label: Dict.poiDistM.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'roadName', label: Dict.roadName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'roadRank', label: Dict.roadRank.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'roadMaxSpeed', label: Dict.roadMaxSpeed.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'midRoute', label: Dict.midRoute.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} }, */
        ]
    },
    tablePropsForMap: {
        tableId: 'vehRouteTableForMap',
        uniqueKey: 'gpsTime',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: true, // 외부에서 MapFloatingInfo를 사용해서 표시
            growToFill: true,
        },
        columns: [
            { id: 'gpsTime', label: '보고시각', width: 165, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'location', label: '위치', width: 400, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'speed', label: '속도(Km/h)', width: 90, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'distKm', label: '운행거리(Km)', width: 100, show: true,
                option:{align: 'right', print:(r,i,v)=>v?ValueMisc.float2str(v/1000,2):'0.00'} },
            { id: 'pwrType', label: '전원타입', width: 60, show: true,
                option:{align: 'center',
                    print:(r,i,v)=>v===1 ? <Battery6BarIcon fontSize={AppWord.SMALL}/> : <ElectricalServicesIcon fontSize={AppWord.SMALL}/>
                } },
            { id: 'posSys', label: '위치타입', width: 80, show: true,
                option:{align: 'center',
                    print:(r,i,v)=>{
                        if(v==='G') return 'GPS';
                        else if(v==='L') return '과거위치';
                        else if(v==='I') return 'ITS';
                        else if(v==='C') return 'Cell';
                        else return '-';
                    }
                 } },
            { id: 'irActionName', label: '업무상태', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'tempr1', label: '전면온도', width: 70, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tempr3', label: '중면온도', width: 70, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tempr2', label: '후면온도', width: 70, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },

        ]
    },
};
